import { render } from "./MsgEmBreve.vue?vue&type=template&id=7642e0e8&scoped=true"
import script from "./MsgEmBreve.vue?vue&type=script&lang=js"
export * from "./MsgEmBreve.vue?vue&type=script&lang=js"

import "./MsgEmBreve.vue?vue&type=style&index=0&id=7642e0e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7642e0e8"]])

export default __exports__